// extracted by mini-css-extract-plugin
export default {"flowsheetWarningPopupFooter":"FlowsheetWarningPopup_flowsheetWarningPopupFooter__KDwNK","flowsheetWarningPopupMessage":"FlowsheetWarningPopup_flowsheetWarningPopupMessage__3L-nj"};